// extracted by mini-css-extract-plugin
export default {"container":"ChatScrollContainer-module__container--z_iNX"};